var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningSmallLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 35,
    viewBox: "0 0 39 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.001,
    y: 5.22607,
    width: 9,
    height: 24,
    fill: "#424242"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9996 1.44317L38.6133 30.218C38.8666 30.6568 39 31.1545 39 31.6611C39 32.1678 38.8666 32.6655 38.6133 33.1043C38.36 33.5431 37.9956 33.9074 37.5569 34.1608C37.1181 34.4141 36.6204 34.5475 36.1137 34.5475H2.88626C2.37961 34.5475 1.88189 34.4141 1.44312 34.1608C1.00435 33.9074 0.639997 33.5431 0.386677 33.1043C0.133357 32.6655 -3.21777e-06 32.1678 0 31.6611C3.21789e-06 31.1545 0.13337 30.6568 0.386695 30.218L17.0004 1.44317C18.1107 -0.481056 20.8874 -0.481056 21.9996 1.44317ZM19.5 24.2491C18.9897 24.2491 18.5002 24.4518 18.1394 24.8126C17.7785 25.1735 17.5758 25.6629 17.5758 26.1733C17.5758 26.6836 17.7785 27.173 18.1394 27.5339C18.5002 27.8948 18.9897 28.0975 19.5 28.0975C20.0103 28.0975 20.4998 27.8948 20.8606 27.5339C21.2215 27.173 21.4242 26.6836 21.4242 26.1733C21.4242 25.6629 21.2215 25.1735 20.8606 24.8126C20.4998 24.4518 20.0103 24.2491 19.5 24.2491ZM19.5 10.7795C19.0287 10.7796 18.5738 10.9526 18.2216 11.2658C17.8694 11.579 17.6444 12.0105 17.5892 12.4786L17.5758 12.7037V20.4006C17.5763 20.8911 17.7641 21.3628 18.1008 21.7194C18.4375 22.076 18.8976 22.2906 19.3872 22.3194C19.8768 22.3481 20.3589 22.1888 20.735 21.8741C21.1111 21.5593 21.3528 21.1128 21.4108 20.6257L21.4242 20.4006V12.7037C21.4242 12.1934 21.2215 11.7039 20.8606 11.3431C20.4998 10.9822 20.0103 10.7795 19.5 10.7795Z",
    fill: "#FAC23D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningSmallLight);
export default __webpack_public_path__ + "static/media/WarningSmallLight.c5eed9d34584f42b842aee769c7d7d3b.svg";
export { ForwardRef as ReactComponent };